
<v-select
  :options="prepareOptions(options)"
  @input="input"
  :value="value"
  :reduce="(option) => option.id"
  label="label"
  :selectable="(option) => !option.isHeader && !option.isfix"
  :clearable="false"
  :disabled="disabled"
>
  <template #option="option">
    <div
      class="ml-0 pl-0"
      style="color: #333; margin-left: 0; padding-left: 0;"
      v-if="option.isHeader"
    >
      <i v-if="option.icon" class="far" :class="option.icon"></i>
      <i v-else class="far fa-arrow-right"></i>
      {{ option.group }}
    </div>
    <span v-else class="ml-5">{{ option.text }}</span>
  </template>

  <template #selected-option="option">
    <div class="d-flex flex-column">
      <small class="font-bold text-xs">{{ option.group }}</small>
      <span>{{ option.text }}</span>
    </div>
  </template>

  <template #search="{ attributes, events }">
    <input class="vs__search" style="height: 38px;" v-bind="attributes" v-on="events" />
  </template>

  <template #open-indicator="{}">
    <span v-if="disabled"></span>
  </template>
</v-select>
